import { Space, Spin } from "antd";
export default function Fallback() {
	return (
		<Space className="h100p w100p flex-d-c-c">
			<Spin delay={200} size="large"></Spin>
		</Space>
	);
}
